export const handleBloodPressure = (param, bioData) =>
	param === 'bloodPressure' &&
	`${bioData['bloodPressureSystolic'] || 'N'}/${
		bioData['bloodPressureDiastolic'] || 'A'
	}`;
